import { queryOptions, useQuery } from '@tanstack/react-query';
import { ListAuditLogsResponse } from '@sourcito/schemas';
import { apiFetch } from './api';

export interface AuditLogsParams {
  action?: string;
  limit?: number;
}

export function auditLogsQuery(params: AuditLogsParams = {}) {
  const search = new URLSearchParams();
  if (params.action) search.set('action', params.action);
  if (params.limit !== undefined) search.set('limit', String(params.limit));
  const qs = search.toString();
  const path = `/api/audit-logs${qs ? `?${qs}` : ''}`;

  return queryOptions({
    queryKey: ['audit-logs', params.action ?? '', params.limit ?? 50] as const,
    queryFn: () =>
      apiFetch<ListAuditLogsResponse>(path, {
        responseSchema: ListAuditLogsResponse,
      }),
    staleTime: 5_000,
  });
}

export function useAuditLogs(params: AuditLogsParams = {}) {
  return useQuery(auditLogsQuery(params));
}
